﻿
(() => {
    angular.module('fliptoWeb')
        .factory('ApiService', ['server', function (server) {
        ///<summary>Analytics/page-tracking service for angular poststay application</summary>

        var GETSTARTEDPOSTURL = "/api/get-started";
        var PARTNERSIGNUPPOSTURL = "/api/partner-signup";
        var PARTNERS_PORTAL_SIGNUP_POST_URL = "/api/partners-portal-signup";
        var CONTACTUSPOSTURL = "/api/contact-us";

        function postGetStarted(data) {
            return server.call('POST', GETSTARTEDPOSTURL + "/" + data.ContactType, data, true);
        }
        function postPartnerSignup(data) {
            return server.call('POST', PARTNERSIGNUPPOSTURL, data, true);
        }
        function postPartnersPortalSignup(data) {
            return server.call('POST', PARTNERS_PORTAL_SIGNUP_POST_URL, data, true);
        }
        function postContactUs(data) {
            return server.call('POST', CONTACTUSPOSTURL, data, true);
        }

        return {
            GetStarted_Post: postGetStarted,
            PartnerSignup_Post: postPartnerSignup,
            PartnersPortalSignup_Post: postPartnersPortalSignup,
            ContactUs_Post: postContactUs,
            WebisodeFuelSubscribe: function (email) {
                return server.call('POST', "/api/webisode-fuel-subscribe", {email});
            }
        }
    }]);
})()

